<template>
  <div class="c-guide" :style="{left: pos.x+'px',top:pos.y+'px'}">
    <p>你可以点击这里，切换到不同的课程哦～</p>
    <button @click="$emit('close')">我知道了</button>
  </div>
</template>

<script>
export default {
  name: 'Guide',
  props: {
    pos: {
      type: Object,
      default: () => ({
        x: 200,
        y: 300,
      }),
    },
  },
};
</script>

<style lang="scss" scoped>
.c-guide {
  width: 221px;
  height: 70px;
  background-image: url('~@/views/pt/images/guide.png');
  background-size: 100% 100%;
  box-sizing: border-box;
  position: fixed;
  z-index: 2;
  color: #fff;
  font-size: 14px;
  padding: 8px 14px 0 21px;
  button {
    width: 74px;
    height: 26px;
    background: #FFFFFF;
    border-radius: 4px;
    color: rgba(25, 137, 250, 1);
    font-size: 13px;
    position: absolute;
    right: 17px;
    bottom: 8px;
  }
}
</style>
